import { Modal } from "react-bootstrap"
import AppModal from "../../Common/AppModal"
import { Character, CharacterStat } from "../../../types"
// import { useDispatch } from "react-redux"
import CharThumbnail from "./CharThumbnail"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBook, faBrain, faEye, faGun, faHandFist, faHandshake, faHeadSideVirus, faHeart, faMeteor, faPersonWalking, faShield, faSquarePlus } from "@fortawesome/free-solid-svg-icons"
import { Condition } from "../../../types/CharacterTypes"
import { getConditionColor, getConditionIcon } from "../helpers/uiHelpers"
import { socket } from "../../../api"

type Props = {
    character: Character
}
const CharacterStats: React.FC<Props> = (props) => {

    const improveStat = (name: CharacterStat) => {
        socket.emit("improveStat", name)
    }

    const imprBtn = (name: CharacterStat): React.ReactNode => {
        if (props.character.exp.pnts > 0) {
            return <FontAwesomeIcon className="clickable ms-2" icon={faSquarePlus} onClick={() => { improveStat(name) }} />
        }
        return <></>
    }

    return (
        <AppModal name="characterStats" title="Character Stats" onClose={() => { }}>
            <Modal.Body className="p-2">
                <div style={{ width: "120px", margin: "10px auto"}}>
                    <CharThumbnail character={props.character} size={120} displayHS />
                </div>

                <div className="text-center"><strong>Level</strong> {props.character.exp.lvl} - <strong>exp</strong> {props.character.exp.exp} / {props.character.exp.next}</div>
                <div className="row text-center">
                    <div className="col-6">
                        <div className=""><span className="color-health"><span className="stat-icon-wrapper"><FontAwesomeIcon icon={faHeart} /></span></span> Health: <span className="statvalue color-health">{props.character.stats.health}/{props.character.stats.calc?.maxHealth}</span></div>

                    </div>
                    <div className="col-6">
                        <div className=""><span className="color-sanity"><span className="stat-icon-wrapper"><FontAwesomeIcon icon={faBrain} /></span></span> Sanity: <span className="statvalue color-sanity">{props.character.stats.sanity}/{props.character.stats.calc?.maxSanity}</span></div>

                    </div>
                </div>

                <div className="mt-2"></div>
                <div className="text-center">Free Stat Points: <span className="statvalue">{props.character.exp.pnts}</span></div>
                <div title="Influence is needed in a variety of tests">
                    <span className="stat-icon-wrapper"><FontAwesomeIcon icon={faHandshake} /></span> Influence: <span className="statvalue">{props.character.stats.calc?.inf}</span>{imprBtn("inf")}
                </div>
                <div title="Lore is needed in a variety of tests">
                    <span className="stat-icon-wrapper"><FontAwesomeIcon icon={faBook} /></span> Lore: <span className="statvalue">{props.character.stats.calc?.lore}</span>{imprBtn("lore")}
                </div>
                <div title="Observation helps you flee from combat">
                    <span className="stat-icon-wrapper"><FontAwesomeIcon icon={faEye} /></span> Observation: <span className="statvalue">{props.character.stats.calc?.obs}</span>{imprBtn("obs")}
                </div>
                <div title="Strength helps you deal damage">
                    <span className="stat-icon-wrapper"><FontAwesomeIcon icon={faHandFist} /></span> Strength: <span className="statvalue">{props.character.stats.calc?.str}</span>{imprBtn("str")}
                </div>
                <div title="Willpower will help you withstand the horrors of monsters">
                    <span className="stat-icon-wrapper"><FontAwesomeIcon icon={faHeadSideVirus} /></span> Willpower: <span className="statvalue">{props.character.stats.calc?.will}</span>{imprBtn("will")}
                </div>

                <div className="mt-4"></div>
                <div title="Armor reduces damage from monsters (dice roll)">
                    <span className="stat-icon-wrapper"><FontAwesomeIcon icon={faShield} /></span> Armor: <span className="statvalue">{props.character.stats.calc?.armr}</span>
                </div>
                <div title="Base damage you do to monsters (dice roll)">
                    <span className="stat-icon-wrapper"><FontAwesomeIcon icon={faGun} /></span> Damage: <span className="statvalue">{props.character.stats.calc?.dmg}</span>
                </div>

                {props.character.conditions.length > 0 && <div className="mt-4">
                    <h5>Conditions</h5>
                    {props.character.conditions.map((cond, i) => <ConditionComp key={i} cond={cond} />)}
                </div>}

            </Modal.Body>
            <Modal.Footer className="p-1" style={{justifyContent: "center"}}>

            </Modal.Footer>
        </AppModal>
    )
}
export default CharacterStats


type ConditionProps = {
    cond: Condition,
}
const ConditionComp: React.FC<ConditionProps> = (props) => {
    return (
        <div>
            <span className="stat-icon-wrapper">
                {getConditionIcon(props.cond.name)}
            </span>
            <span style={{color: getConditionColor(props.cond.name)}} className="statvalue">
                {props.cond.displayName}
            </span>
            {props.cond.categories.includes("reckoningTrigger") && <span className="ms-1"><FontAwesomeIcon title="Reckoning may trigger an effect" icon={faMeteor} /></span>}
            {props.cond.categories.includes("travelTrigger") && <span className="ms-1"><FontAwesomeIcon title="Traveling may trigger an effect" icon={faPersonWalking} /></span>}
            <span className="ms-1" style={{fontStyle: "italic", fontSize: "11pt"}}>
                {/* &nbsp;-&nbsp; */}
                {props.cond.description}
            </span>
        </div>
    )
}